export default __webpack_public_path__ + "static/media/IFSC.4adc095b.png";